export default __webpack_public_path__ + "static/fr-28f13d86d83f2c4028a7d9a3130d84a3.svg";